/* import __COLOCATED_TEMPLATE__ from './messages-status-icon.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action, get } from '@ember/object';
import { inject as service } from '@ember/service';
import { messageCenterGetThreadPrimaryRecipient } from 'sh-www/helpers/message-center/get-thread-primary-recipient';

class MessagesStatusIconComponent extends Component {
  @service('state-manager-hybrids/heartbeat-state-manager-hybrid')
  heartbeatStateManager;

  @service
  session;

  @tracked
  open = false;

  get currentUser() {
    return this.session.currentUser;
  }

  get inboxUnreadCount() {
    return get(this.heartbeatStateManager, 'threadsUnreadInbox');
  }

  get mostRecentInboxThreadsModel() {
    const { currentUser } = this.session;
    const currentUserId = Number.parseInt(currentUser.id);

    return get(this.heartbeatStateManager, 'mostRecentInboxThreads').map((thread) => {
      const threadRecipient = messageCenterGetThreadPrimaryRecipient([thread, currentUser]);

      const userInfo = get(thread, 'etc.relationships.users').find(
        (userInfo) => {
          const userId = get(userInfo, 'user_id');
          return Number.parseInt(userId) === currentUserId
        },
      );

      const lastUpdated = thread.lastMessageDate;
      const lastRead = new Date(get(userInfo, 'last_read_at'));
      const unread = lastRead < lastUpdated;

      return {
        id: thread.id,
        thread,
        threadRecipient,
        unread,
      };
    });
  }

  @action
  setOpen(isOpen) {
    this.open = isOpen;
  }
}

export default MessagesStatusIconComponent;
